import React, { useEffect } from 'react'
import ErrorPage from '@navent-jobs/ui-kit/components/errorPage'
import { useQuery } from '../../hooks/query-hook'
import errorPagesSettings from '../../constants/error-pages-settings'

const Component = props => {
  const query = useQuery()
  const errorMessage = query?.get('message')
  const errorStacktrace = query?.get('stacktrace')

  useEffect(() => {
    if (errorMessage) console.error('errorMessage: ', errorMessage)
    if (errorStacktrace) console.error('errorStacktrace: ', errorStacktrace)
  }, [errorMessage, errorStacktrace])

  return <ErrorPage statusCode={props?.statusCode} setting={errorPagesSettings} />
}

export default Component
